import { Form, DatePicker, Button } from "antd";
import form from "antd/lib/form";
import moment from "moment";
import React, { useState } from "react";
import { AiOutlineUnorderedList } from "react-icons/ai";
import { FiFilter } from "react-icons/fi";
import { RiFilterOffLine } from "react-icons/ri";
import Moment from "react-moment";
import { NavLink } from "react-router-dom";
import ServiceChart from "./components/ServiceChart";
import ServiceType from "./components/ServiceType";
const { RangePicker } = DatePicker;

export default function ChartHistory() {
  const [form] = Form.useForm();
  const [startDate, setStateDate] = useState(
    moment(new Date()).format("YYYYMMDD")
  );
  const [endDate, setEndDate] = useState(moment(new Date()).format("YYYYMMDD"));

  const onDateChange = (date: any) => {
    setStateDate(moment(new Date(date)).format("YYYYMMDD"));
    setEndDate(moment(new Date(date)).format("YYYYMMDD"));
  };

  const onRangeChange = (date: any) => {
    setStateDate(moment(new Date(date[0])).format("YYYYMMDD"));
    setEndDate(moment(new Date(date[1])).format("YYYYMMDD"));
  };

  const clearDate = () => {
    form.resetFields();
    setStateDate(moment(new Date()).format("YYYYMMDD"));
    setEndDate(moment(new Date()).format("YYYYMMDD"));
  };
  return (
    <div className=" bg-gray-100">
      <div className="flex justify-between items-center border-b border-gray-300 py-2 mx-4">
        <div className="flex">
          <Form layout="inline" form={form}>
            <Form.Item name="picker" initialValue={moment()}>
              <DatePicker
                onChange={onDateChange}
                defaultValue={moment()}
                format={"DD-MM-YYYY"}
              />
            </Form.Item>
            <Form.Item name="ranger">
              <RangePicker
                allowClear={true}
                onChange={onRangeChange}
                format={"DD-MM-YYYY"}
              />
            </Form.Item>
            <Button className="" onClick={() => clearDate()}>
              <RiFilterOffLine color="#6b7280" />
            </Button>
          </Form>

          <div className="border ml-2 bg-white flex justify-center items-start px-2 py-1">
            <NavLink
              to={"/service/history"}
              className="flex items-center text-gray-900"
            >
              <AiOutlineUnorderedList color="#323232" />
              <span className="ml-2">View in List</span>
            </NavLink>
          </div>
        </div>
        <div className="flex items-center">
          <div className="">
            {startDate === "19700101" ? null : (
              <span className="font-bold text-gray-600">
                <Moment format="Do MMM YYYY">{startDate}</Moment>
              </span>
            )}
            {startDate === endDate ? null : (
              <>
                <span className="mx-2">-</span>
                <span className="font-bold text-gray-600">
                  <Moment format="Do MMM YYYY">{endDate}</Moment>
                </span>
              </>
            )}
          </div>
          <div className="border-l px-2 ml-2 flex items-center border p-1 border-gray-300 bg-white">
            <FiFilter />
            <span className="ml-2">Filters</span>
          </div>
        </div>
      </div>
      <div className="flex flex-col border border-gray-300 mx-4 rounded-lg mt-2 bg-white h-96">
        <div className="" style={{ height: 300 }}>
          <ServiceChart startDate={startDate} endDate={endDate} />
        </div>
      </div>
    </div>
  );
}
